import React, { useState } from 'react';
import { createRoot } from 'react-dom/client';
import { SuiButton, SuiModal, SuiThemeProvider } from '@splashthat/sui';

import { splashLogoElement } from 'common/constants';
import { getInstance as getBootstrap } from 'utils/bootstrap';

import { PageContainerStyled, StyledTitle, FooterStyled, LogoContainerStyled, ParagraphStyled } from './styles';
import './styles.styl';
import Form from './Form';

const bootstrap = getBootstrap();

const LABEL_CONTACT_ORGANIZER = 'Contact the organizer';

const AppWrapper = () => {
    const [open, setOpen] = useState(false);

    function toggleModal() {
        setOpen(!open);
    }

    const ocbDomain = bootstrap.get('ocbDomain');
    const linkDestination = ocbDomain ? `//${ocbDomain}` : '#';

    return (
        <SuiThemeProvider>
            <PageContainerStyled data-qa="error-page-wrap">
                <StyledTitle>{bootstrap.get('message')}</StyledTitle>
                <SuiButton label={LABEL_CONTACT_ORGANIZER} onClick={toggleModal} variation="secondary" size="large" />
                <SuiModal
                    showCloseButton
                    size="thin"
                    overlay="dark"
                    open={open}
                    onRequestClose={() => setOpen(false)}
                    heightMatchContent
                >
                    <Form
                        onSubmissionSuccess={() => {
                            setTimeout(() => {
                                setOpen(false);
                            }, 2000);
                        }}
                    />
                </SuiModal>
                <FooterStyled>
                    <LogoContainerStyled>
                        <a href={linkDestination}>{splashLogoElement}</a>
                    </LogoContainerStyled>
                    <ParagraphStyled>
                        COPYRIGHT &copy; {new Date().getFullYear()} SPLASH. ALL RIGHTS RESERVED.
                    </ParagraphStyled>
                </FooterStyled>
            </PageContainerStyled>
        </SuiThemeProvider>
    );
};

const root = createRoot(document.getElementById('root'));
root.render(<AppWrapper />);
